{
  "loading": "Carregando...",
  "placeholder": "Selecionar…"
}
